import React from "react";
import { DOCS_METADATA_PATH } from "../../../../../router/RouterUtils";
import AppMarketplaceImg from "../../../../../assets/img/app-marketplace.png";
import { Card, Text } from "@merge-api/merge-javascript-shared";
import FeatureCard from "../shared/FeatureCard";
import { Codesandbox } from "lucide-react";

const Metadata = () => {
  return (
    <Card className="p-6 mx-auto w-full lg:w-3/4">
      <Text variant="h3" className="mb-1">
        Integration metadata
      </Text>
      <Text as="p" className="mb-6 text-gray-40">
        Use Integration metadata to programmatically fetch information about the integrations Merge
        offers
      </Text>

      <Text as="p">
        Use the Merge API's Integration metadata endpoint to fetch integration names, identifiers,
        images, brand colors, and more.
      </Text>
      <Text as="p">
        You can use this data to create a custom integrations menu or applications marketplace for
        your product.
      </Text>

      <div className="flex justify-center my-16">
        <img
          src={AppMarketplaceImg}
          className="max-w-[400px] w-full h-auto"
          alt="App Marketplace"
        />
      </div>
      <FeatureCard
        icon={<Codesandbox size={16} />}
        title="Integration metadata"
        docsPath={DOCS_METADATA_PATH}
      >
        <Text>Programmatically fetch information about Merge integrations</Text>
      </FeatureCard>
    </Card>
  );
};

export default Metadata;
